var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"8"}},[_c('ITListEmployee')],1),_c('v-col',{attrs:{"cols":"12","sm":"12","md":"8","lg":"4"}},[_c('ITList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }